
import { WorldCountry } from './types';

export const iraqData: WorldCountry = {
  code: 'IQ',
  name: 'Iraq',
  slug: 'iraq',
  population: 40222493,
  topCities: [
    { name: 'Baghdad', slug: 'baghdad', population: 7711305 },
    { name: 'Basra', slug: 'basra', population: 2600000 },
    { name: 'Mosul', slug: 'mosul', population: 1694000 },
    { name: 'Erbil', slug: 'erbil', population: 1612700 },
    { name: 'Sulaymaniyah', slug: 'sulaymaniyah', population: 1784853 },
    { name: 'Najaf', slug: 'najaf', population: 1000000 },
    { name: 'Karbala', slug: 'karbala', population: 711530 },
    { name: 'Kirkuk', slug: 'kirkuk', population: 601433 },
    { name: 'Hilla', slug: 'hilla', population: 455700 },
    { name: 'Ramadi', slug: 'ramadi', population: 432885 }
  ]
};
